<button
  class="qx-sidebar-backdrop"
  type="button"
  aria-label="Close navigation"
  (click)="closeMobileMenu()"
>
</button>

<aside
  class="qx-sidebar"
  [class.qx-collapsed]="isCollapsed"
>
  <div
    class="qx-sidebar-header"
  >
    <a
      class="qx-brand"
      routerLink="/home"
      aria-label="PI Signage home"
    >
      <img
        *ngIf="isCollapsed"
        class="qx-logo qx-logo-compact"
        src="assets/logos/pi-signage-logo.svg"
        alt="PI Signage"
      >
      <img
        *ngIf="!isCollapsed"
        class="qx-logo qx-logo-full qx-logo-light"
        src="assets/logos/pi-signage-full-logo.svg"
        alt="PI Signage"
      >
      <img
        *ngIf="!isCollapsed"
        class="qx-logo qx-logo-full qx-logo-dark"
        src="assets/logos/pi-signage-full-logo-dark.svg"
        alt="PI Signage"
      >
    </a>
  </div>

  <nav
    class="qx-nav"
    aria-label="Primary navigation"
  >
    <div
      class="qx-section"
    >
      <a
        class="qx-direct-link"
        routerLink="/home"
        routerLinkActive="qx-direct-link-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <i
          class="pi pi-home qx-section-icon"
        >
        </i>
        <span
          class="qx-section-label"
        >
          Home
        </span>
      </a>
      <div
        class="qx-flyout qx-flyout-direct"
      >
        <div
          class="qx-flyout-inner"
        >
          <a
            class="qx-flyout-title"
            routerLink="/home"
          >
            Home
          </a>
        </div>
      </div>
    </div>

    <div
      *ngIf="canViewDashboard"
      class="qx-section"
    >
      <a
        class="qx-direct-link"
        routerLink="/dashboard"
        routerLinkActive="qx-direct-link-active"
      >
        <i
          class="pi pi-chart-bar qx-section-icon"
        >
        </i>
        <span
          class="qx-section-label"
        >
          Dashboard
        </span>
      </a>
      <div
        class="qx-flyout qx-flyout-direct"
      >
        <div
          class="qx-flyout-inner"
        >
          <a
            class="qx-flyout-title"
            routerLink="/dashboard"
          >
            Dashboard
          </a>
        </div>
      </div>
    </div>

    <div
      *ngIf="signageSection.items.length"
      class="qx-section"
    >
      <button
        class="qx-section-header"
        type="button"
        [class.qx-section-active]="signageSection.expanded"
        (click)="toggleSection()"
      >
        <i
          class="qx-section-icon"
          [ngClass]="signageSection.icon"
        >
        </i>
        <span
          class="qx-section-label"
        >
          {{ signageSection.label }}
        </span>
        <i
          class="pi pi-chevron-down qx-chevron"
          [class.qx-chevron-open]="signageSection.expanded"
        >
        </i>
      </button>

      <ul
        class="qx-items"
        [class.qx-items-open]="signageSection.expanded"
      >
        <li
          *ngFor="let item of signageSection.items"
          class="qx-menu-item"
          routerLinkActive="qx-active"
        >
          <a
            class="qx-menu-item-link"
            [routerLink]="item.route"
          >
            <i
              class="qx-item-icon"
              [ngClass]="item.icon"
            >
            </i>
            <span
              class="qx-item-label"
            >
              {{ item.label }}
            </span>
          </a>
        </li>
      </ul>

      <div
        class="qx-flyout"
      >
        <div
          class="qx-flyout-inner"
        >
          <span
            class="qx-flyout-title"
          >
            {{ signageSection.label }}
          </span>
          <ul>
            <li
              *ngFor="let item of signageSection.items"
              routerLinkActive="qx-active"
            >
              <a
                class="qx-flyout-item-link"
                [routerLink]="item.route"
              >
                <i
                  [ngClass]="item.icon"
                >
                </i>
                {{ item.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <div
    class="qx-toggle-footer"
  >
    <button
      class="qx-toggle-btn-small"
      type="button"
      title="Toggle sidebar"
      aria-label="Toggle sidebar"
      (click)="toggleSideBar()"
    >
      <i
        class="pi"
        [class.pi-chevron-right]="isCollapsed"
        [class.pi-chevron-left]="!isCollapsed"
      >
      </i>
    </button>
  </div>

  <div
    *ngIf="canViewConfiguration"
    class="qx-sidebar-bottom"
  >
    <div
      class="qx-section"
    >
      <a
        class="qx-direct-link"
        routerLink="/setting"
        routerLinkActive="qx-direct-link-active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <i
          class="pi pi-cog qx-section-icon"
        >
        </i>
        <span
          class="qx-section-label"
        >
          Configuration/Setup
        </span>
      </a>
      <div
        class="qx-flyout qx-flyout-direct"
      >
        <div
          class="qx-flyout-inner"
        >
          <a
            class="qx-flyout-title"
            routerLink="/setting"
          >
            Configuration/Setup
          </a>
        </div>
      </div>
    </div>
  </div>
</aside>
